// extracted by mini-css-extract-plugin
export default {"mainPageButtons":"Buttons_mainPageButtons__wPquD"};